<template>
  <div>
    <div
      v-for="(item, index) in get_notifications"
      :key="index"
      @click="item.type === 'notification' && closeNotification(item, index)"
    >
      <v-snackbar
        class="custom-snackbar rounded-sm"
        :color="'#ffffff'"
        :multi-line="true"
        :timeout="item.type === 'notification' ? 4000 : 60000"
        :right="true"
        :top="true"
        :value="item.message"
        style="color: #444444; cursor: pointer"
        @input="item.type === 'notification' && closeNotification(item, index)"
        transition="scroll-y-reverse-transition"
      >
        <v-card class="pa-0 ma-0" light elevation="0">
          <v-card-title>
            <div v-if="item.type === 'notification'">
              <v-icon
                :style="`color: ${item.error ? '#FF3C5F' : '#00ab55'}`"
                size="36"
                >{{
                  item.error ? 'mdi-alert-circle-outline' : 'mdi-check'
                }}</v-icon
              >
              <span class="font-size-14 color-1 ml-4 cardHeader">{{
                item.message
              }}</span>
            </div>
            <div
              v-else
              class="d-flex align-center justify-space-between width-100"
            >
              <div
                v-if="
                  item.notification_type === 'turn_mention_posted' ||
                  item.notification_type === 'container_mention_posted'
                "
                class="d-flex align-center"
              >
                <BaseAppAvatar size="36" :user="item.owner" />
                <div class="ml-2">
                  <span class="font-size-16 font-weight-bold color-2">{{
                    item.name
                  }}</span>
                </div>
                <div>
                  <span class="font-size-14 color-1 ml-2 mr-4 cardHeader">{{
                    item.message
                  }}</span>
                </div>
              </div>
              <div class="d-flex align-center" v-else>
                <template v-if="item.metadata && item.metadata.turn">
                  <BaseAppLineAvatar
                    :line="item.metadata.turn.line"
                    :size="20"
                  />
                </template>
                <span class="font-size-14 color-1 ml-2 mr-4 cardHeader">{{
                  item.message
                }}</span>
              </div>
            </div>
          </v-card-title>
          <v-card-actions v-if="item.type === 'mention'" class="px-0">
            <v-btn
              v-if="item?.metadata?.type === 'confirm'"
              class="ma-0"
              color="primary"
              text
              @click="confirmNotification(item, index)"
              >Confirm</v-btn
            >
            <v-btn
              v-else
              class="ma-0"
              color="primary"
              text
              @click="viewNotification(item, index)"
              >View</v-btn
            >
            <v-btn
              class="ma-0"
              color="primary"
              style="margin-left: -8px"
              text
              @click="closeNotification(false, index)"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseAppAvatar from '@/components/BaseAppAvatar';
import BaseAppLineAvatar from '@/components/BaseAppLineAvatar';

export default {
  name: 'BaseAppNotifications',
  components: {
    BaseAppAvatar,
    BaseAppLineAvatar,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('auth', ['get_user', 'get_notifications']),
  },
  methods: {
    closeNotification($event, index) {
      const { type } = $event;

      if ($event && type === 'mention') {
        if (this.$route.name.toLowerCase() !== 'notifications') {
          this.$router.push({
            path: '/notifications',
          });
        }
      }

      const newNotifications = this.get_notifications;

      newNotifications.splice(index, 1);

      this.$store.dispatch('auth/set_notifications', newNotifications, {
        root: true,
      });
    },
    confirmNotification(item, index) {
      this.$router.push({
        path: '/request-load',
        query: {
          page: 'yourloads',
          id: item.metadata.commitment.id,
          type: 'confirm',
        },
      });
      this.closeNotification(false, index);
    },
    // Navigate to the specific path when click on the view notification
    viewNotification(item, index) {
      const data = item.metadata;
      if (
        item.notification_type === 'turn_approval_mention_posted' ||
        item.notification_type === 'turn_declined_mention_posted'
      ) {
        this.$router.push({
          path: `/network?id=${data.turn.turn_id}`,
        });
      } else if (
        item.notification_type === 'container_mention_posted' ||
        item.notification_type === 'turn_mention_posted'
      ) {
        this.$router.push({
          path: `/network?id=${data.turn.id}&comment=true`,
        });
      } else if (
        item.notification_type === 'subscription_created_mention_posted' ||
        item.notification_type === 'subscription_updated_mention_posted'
      ) {
        this.$router.push({ path: '/settings' });
      } else if (
        item.notification_type === 'commitment_mention_posted' ||
        item.notification_type === 'agency_mention_posted'
      ) {
        this.$router.push({ path: '/notifications' });
      } else if (item.notification_type === 'document_mention_posted') {
        this.$router.push({ path: '/settings?page=onboarding' });
      } else {
        const reservationId = data.reservation.id;
        if (item.notification_type === 'reservation_sign_mention_posted') {
          this.$router.push({
            path: `/find-empty-container?reservationId=${reservationId}#confirm`,
          });
        } else {
          this.$router.push({
            path: `/find-empty-container?reservationId=${reservationId}`,
          });
        }
      }
      this.closeNotification(false, index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.cardHeader {
  word-break: break-word;
}
</style>
